/**
 * Lettura e scrittura della dashboard di una persona (tabella
 * dashboard_layouts, migrazione 23). Ognuno vede e scrive solo la propria
 * riga: lo garantisce la regola di accesso del database.
 *
 * Nessuna riga vuol dire "la base del ruolo": salvare una disposizione
 * uguale alla base cancella la riga, cosi' la persona continua a ricevere i
 * miglioramenti futuri della base.
 */

import { supabase } from '../supabase';
import type { Json } from '../../types/database.types';

/** La disposizione salvata, o null se la persona non ha mai personalizzato. */
export async function leggiDisposizione(utenteId: string): Promise<unknown | null> {
  const { data, error } = await supabase
    .from('dashboard_layouts')
    .select('layout')
    .eq('user_id', utenteId)
    .maybeSingle();
  if (error) throw error;
  return data?.layout ?? null;
}

/** Salva la disposizione; con null torna alla base del ruolo. Solleva l'errore. */
export async function scriviDisposizione(utenteId: string, layout: Json | null): Promise<void> {
  const { error } = layout === null
    ? await supabase.from('dashboard_layouts').delete().eq('user_id', utenteId)
    : await supabase.from('dashboard_layouts').upsert({ user_id: utenteId, layout }, { onConflict: 'user_id' });
  if (error) throw error;
}
